import { withAuthorization } from "../../../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { DefaultPage } from "../../../../structure/Page/DefaultPage/DefaultPage";

const CreateBillPageContent = lazy(() => import("./CreateBillPageContent"));

function CreateBillPageInternal() {
    return (
        <DefaultPage>
            <CreateBillPageContent />
        </DefaultPage>
    );
}

export const CreateBillPage = withAuthorization(getAuthorizationGuard(Role.OWNER, Role.ADMIN))(CreateBillPageInternal);
